export default "__VITE_ASSET__Dg3SbbzY__"